import { Sun, Moon, Monitor } from "@phosphor-icons/react";
import { useTheme } from "../lib/theme";

/**
 * Theme toggle that cycles Light → Dark → System.
 * Shows an icon matching the CURRENT preference (not the resolved one),
 * and a small tooltip-title for clarity.
 */
export default function ThemeToggle() {
  const { preference, resolved, cycle } = useTheme();

  const label =
    preference === "light" ? "Light" : preference === "dark" ? "Dark" : "System";
  const Icon =
    preference === "light" ? Sun : preference === "dark" ? Moon : Monitor;
  const next =
    preference === "light" ? "Dark" : preference === "dark" ? "System" : "Light";

  return (
    <button
      onClick={cycle}
      data-testid="theme-toggle"
      data-theme-preference={preference}
      data-theme-resolved={resolved}
      title={`Theme: ${label} (click for ${next})`}
      aria-label={`Switch theme (current: ${label})`}
      className="neu-btn w-10 h-10 rounded-full flex items-center justify-center text-foreground/80 hover:text-indigo"
    >
      <Icon size={16} weight="duotone" />
    </button>
  );
}
